/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { v4 as uuidv4 } from 'uuid';
import cx from 'classnames';
import $ from 'jquery';
import { withTranslation } from 'react-i18next';
import { trim } from 'lodash';
import { Scrollbars } from 'react-custom-scrollbars-2';
import InputElement from 'react-input-mask';
import Dropzone from 'react-dropzone';
import {
  Modal, Loader, Label, Message, Icon
} from 'semantic-ui-react';
import api from '../../api';
import { LICENSE_REGEX } from '../../constants/settings';
import searchIcon from '../../images/components/contnets_header/searchIcon.png';

class LicenseSystem extends Component {
  constructor(props) {
    super(props);
    const { state } = this.props;
    this.modalBody = null;
    this.state = {
      isCompanyLoading: false,
      isScrollLoading: false,
      isQuotaLoading: false,
      hasMore: false,
      error: false,
      currentPage: 1,
      licenseList: [],
      searchKeyword: '',
      quota: '',
      storage: '',
      //count: 0,
      //maxPages: 0,
      pageSize: 8,
      //recordCount: 10,
      selectedRow: 0,
      selectedCompanyId: '',
      errors: {
        license: '',
        name: '',
      },
      mode: state.user.isSuperAdmin ? 'create' : 'edit',
      isModalOpen: false,
      isRemoveModalOpen: false,
      modalIsOpen: false,
      modalAlertMsg: '',
      modalAlertTitle: '',
      modalAlert: false,
      trick: false,
      errSearch: false,
      isFocus: false,
      newEmailName: '',
      emailList: [],
    };
    this.onChangeSearch = this.onChangeSearch.bind(this);
    this.handleDrop = this.handleDrop.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleLicenseChange = this.handleLicenseChange.bind(this);
    //this.handleDatesChange = this.handleDatesChange.bind(this);
    this.handleModal = this.handleModal.bind(this);
    this.handleRemoveModal = this.handleRemoveModal.bind(this);
    this.handleCloseAlert = this.handleCloseAlert.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleOnScroll = this.handleOnScroll.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.addNewEmail = this.addNewEmail.bind(this);
    this.addNewEmailKeyPress = this.addNewEmailKeyPress.bind(this);
    this.setErrorMsg = this.setErrorMsg.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.onUpdateLicenseList = this.onUpdateLicenseList.bind(this);
    this.getCompanyList = this.getCompanyList.bind(this);
  }

  componentDidMount() {
    this.getQuotaData();

    $(document).on('mouseover', '.setting_project_content .setting_project_table .content_wrapper', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { licenseList } = this.state;

    if (prevState.licenseList.length !== licenseList.length && licenseList.length !== 0) {
      this.onUpdateLicenseList();
    }
  }

  componentWillUnmount() {
    if (this.loadInterval) {
      clearInterval(this.loadInterval);
      this.loadInterval = false;
    }
  }

  handleSearch = (event) => {
    //const { licenseList } = this.state;
    //let newState;
    if (event.key === 'Enter') {
      if (event.target.value === '' || event.target.value.length < 2) {
        this.setState(
          {
            errSearch: true,
            isFocus: false,
          },
          () => {
            setTimeout(() => {
              this.setState({
                errSearch: false,
                isFocus: true,
              });
            }, 1500);
          }
        );
        return false;
      }
      setTimeout(() => {
        this.setState({
          isFocus: false,
        });
      }, 1500);
      this.onChangeSearch(event.target.value);
    }
  };

  handleFocus() {
    this.setState({
      isFocus: true,
    });
  }

  handleBlur() {
    this.setState({
      isFocus: false,
    });
  }

  handleLicenseChange() {
    this.setErrorMsg('license');
  }

  handleNameChange(event) {
    this.props.state.company.setName(event.target.value);
    this.setErrorMsg('name');
  }

  handleEmailChange(e) {
    const { value } = e.target;

    this.setState({
      newEmailName: value.toLowerCase(),
    });
    this.setErrorMsg('email');
  }

  handleDrop(files) {
    const { t } = this.props;
    try {
      const data = new FormData();
      data.append('input_license', files[0]);

      api.uploadLicenseKey(data)
        .then((response) => {
          if (response.response) {
            const value = response.response.license_key.replace(/[^a-zA-Z0-9 ]/g, '').toUpperCase();
            this.props.state.company.setLicenseKey(value);
            this.props.state.company.setIsFileUploaded(true);
            this.props.state.company.setLicenseInfo(response.response);
          }
        })
        .catch((err) => {
          const o = err.data.response;
          if (o.error_description) {
            if (Array.isArray(o.error_description)) {
              this.setErrorMsg('license', o.error_description[0]);
            } else {
              this.setErrorMsg('license', o.error_description);
            }
          } else {
            this.setErrorMsg('license', t('modal.error.invalid_license'));
          }
        });
    } catch (e) {
      this.setErrorMsg('license', t('modal.error.invalid_license'));
    }
  }

  handleChange(event) {
    const value = event.target.value
      .replace(/[^a-zA-Z0-9 ]/g, '')
      .toUpperCase();
    this.props.state.company.setLicenseKey(value);
    this.props.state.company.setIsFileUploaded(false);
    this.handleLicenseChange();
  }

  handleModal() {
    const { emailList } = this.state;
    event.stopPropagation();
    //this.isLoading = true;
    //let createCompany;
    const isNew = this.state.mode === 'create';
    const isAdmin = this.props.state.user.role === 'admin';
    const isSuperAdmin = this.props.state.user.role === 'super_user';
    //    this.props.state.company.updateCompanySettings(isNew, isAdmin);

    const data = {
      name: this.props.state.company.name,
      license_key: this.props.state.company.licenseKey,
    };

    if (!isNew) {
      data.selected_company_id = this.props.state.company.companyId;
    }

    if (isAdmin) {
      data.username = this.props.state.company.nickName;
      data.password = this.props.state.company.password;
      data.address = this.props.state.company.address;
      data.domain = this.props.state.company.domain;
      data.port = this.props.state.company.port;
      data.from = this.props.state.company.host;
    }

    if (isSuperAdmin) {
      if (emailList.length !== 0) {
        const newArray = emailList.map((item) => {
          return item.name;
        });
        this.props.state.company.setScanNotificationEmail(newArray);
      } else {
        this.props.state.company.setScanNotificationEmail([]);
      }
      data.scan_notification_email = this.props.state.company.scanNotificationEmail;
    }

    delete this.props.state.company.licenseInfo.name;

    if (this.props.state.company.isFileUploaded) {
      data.apply_method = 'upload';
      Object.assign(data, this.props.state.company.licenseInfo);
    } else {
      data.apply_method = 'string';
    }

    if (isNew) {
      this.createCompanySettings(data);
    } else {
      this.updateCompanySettings(data);
    }

  }

  handleRemoveModal() {
    const { state, t } = this.props;
    this.setState({
      trick: true,
      licenseList: [],
      selectedRow: 0,
    }, () => {
      api.removeCompany(this.state.selectedCompanyId)
        .then((response) => {
          if (response.response) {
            this.setState({
              isRemoveModalOpen: false,
            }, () => {
              if (state.user.isSuperAdmin) {
                this.getCompanyList(1);
              }
            });
          }
        })
        .catch((response) => {
          this.setState({
            modalAlertTitle: t('modal.title.attention'),
            modalAlertMsg: response.statusText,
            modalAlert: true,
          });
        });
    });
  }

  handleSave() {
    if (this.validateFields()) {
      this.setState({
        isModalOpen: true,
      });
    }
  }

  handleAdd() {
    this.setState({
      mode: 'create',
      selectedRow: 0,
      emailList: [],
    });
    this.props.state.company.saveCompanyData({});
  }

  handleDelete() {
    this.setState({
      isRemoveModalOpen: true,
    });
  }

  handleCloseAlert() {
    this.setState({ modalAlert: false });
    this.closeModal();
  }

  handleOnScroll = (event) => {
    const {
      getCompanyList,
      state: {
        error,
        isLoading,
        hasMore,
      },
    } = this;

    const { scrollTop, scrollHeight, clientHeight } = event.target;
    const scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;

    if (error || isLoading || !hasMore) {
      return;
    }
    if (scrolledToBottom) {
      getCompanyList(this.state.currentPage + 1);
    }
  };

  handleClick = (idx) => {
    const { licenseList } = this.state;
    const { companyId } = licenseList[idx];

    this.setState({
      selectedRow: idx,
      selectedCompanyId: companyId,
      newEmailName: '',
    }, () => {
      this.getCompanyDetail(companyId);
    });
  };

  onUpdateLicenseList() {
    const {
      licenseList, trick, mode, selectedRow
    } = this.state;

    if (mode === 'edit' && trick === false) {
      const { companyId } = licenseList[selectedRow] || licenseList[0];
      this.setState({
        selectedCompanyId: companyId,
      }, () => {
        this.getCompanyDetail(companyId);
      });
    } else {
      const { companyId } = licenseList[0];
      this.setState({
        selectedCompanyId: companyId,
      }, () => {
        this.getCompanyDetail(companyId);
      });
    }
  }

  onChangeSearch = (value) => {
    this.setState({
      searchKeyword: value,
      licenseList: [],
    }, () => {
      this.getCompanyList();
    });
  };

  getQuotaData() {
    const { state } = this.props;
    this.setState({
      isQuotaLoading: true,
    }, () => {
      api.getQuotaData()
        .then((response) => {
          const data = response.response;
          this.setState({
            quota: data.quota,
            storage: data.storage,
            isQuotaLoading: false,
          });
          if (state.user.isSuperAdmin) {
            this.loadInterval = setInterval(this.getCompanyList(this.state.currentPage), 10);
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isQuotaLoading: false,
          });
          if (state.user.isSuperAdmin) {
            this.loadInterval = setInterval(this.getCompanyList(this.state.currentPage), 10);
          }
        });
    });
  }

  getByteLength(text) {
    let l = 0;
    for (let i = 0; i < text.length; i++) l += (text.charCodeAt(i) > 128) ? 2 : 1;
    // return text.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, '$&$1$2').length;
    return l;
  }

  getCompanyList(pageNo) {
    const { pageSize, searchKeyword } = this.state;
    const obj = {
      pageNum: pageNo || 1,
      limitCnt: pageSize,
      search: searchKeyword,
    };

    if (pageNo === 1) {
      this.setState({
        isCompanyLoading: true,
        licenseList: [],
      }, () => {
        this.getCompanyLoadingCallback(obj);
      });
    } else {
      this.setState({
        isScrollLoading: true,
      }, () => {
        this.getCompanyLoadingCallback(obj);
      });
    }
  }

  getCompanyLoadingCallback = (obj) => {
    const {
      licenseList
    } = this.state;
    api.getCompanyList(obj)
      .then((response) => {
        if (response.response) {
          const nextLicenseList = response.response.map((item) => {
            return {
              companyId: item.company_id,
              licenseKey: item.license_key,
              companyName: item.name,
              managedName: item.managed_name,
              periodUsage: item.quota_period_rate,
              todayUsage: item.quota_daily_rate,
              allUsage: item.quota_all,
              emailCount: item.scan_notification,
            };
          });
          this.setState({
            //recordCount: response.pagination.count,
            pageSize: response.pagination.per_page,
            currentPage: response.pagination.current,
            hasMore: response.pagination.next !== null,
            licenseList: [
              ...licenseList,
              ...nextLicenseList,
            ],
            isCompanyLoading: false,
            isScrollLoading: false,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isCompanyLoading: false,
          isScrollLoading: false,
        });
      });
  };

  getCompanyDetail = (companyId) => {
    api.getCompanyDetail(companyId)
      .then((response) => {
        if (response.response) {
          this.props.state.company.saveCompanyData(response.response);
          const data = response.response;

          const newList = data.scan_notification_email.map((item, idx) => {
            return {
              id: idx,
              name: item
            };
          });

          this.setState({
            mode: 'edit',
            trick: false,
            emailList: newList,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  setErrorMsg(field, message = '') {
    const { errors } = this.state;
    this.setState({
      errors: Object.assign(errors, {
        [field]: message,
      }),
    });
  }

  addNewEmail() {
    const { emailList, newEmailName } = this.state;
    if (!this.checkEmailValidate(newEmailName)) {
      return;
    }
    const data = {
      id: 'new',
      name: newEmailName,
    };

    this.setState({
      emailList: [data, ...emailList],
    });
  }

  addNewEmailKeyPress(e) {
    const { emailList, newEmailName } = this.state;
    if (e.key === 'Enter') {
      if (!this.checkEmailValidate(newEmailName)) {
        return;
      }
      const data = {
        id: 'new',
        name: newEmailName,
      };

      this.setState({
        emailList: [data, ...emailList],
      });
    }
  }

  removeEmail(name) {
    const { emailList } = this.state;
    const newState = emailList.filter((el) => {
      return el.name !== name;
    });

    this.setState({
      emailList: newState,
    });
  }

  async createCompanySettings(data) {
    const { state, t } = this.props;
    let v;
    try {
      v = await api.createCompanySettings(data);
      this.props.state.company.saveCompanyData(v.response);
      this.setState({
        isModalOpen: false,
        licenseList: [],
        selectedRow: 0,
        quota: '',
        storage: '',
        errors: {
          license: '',
          name: '',
        },
      }, () => {
        if (state.user.isSuperAdmin) {
          this.getCompanyList(this.state.currentPage);
        }
        this.getQuotaData();
      });
      ///this.isLoading = false;
      return v;
    } catch (err) {
      const o = err.data.response;
      if (o.error_description) {
        if (Array.isArray(o.error_description)) {
          this.modalBody = (
            <span>
              <div>Update failed: </div>
              <ol style={{ listStyle: 'decimal inside', fontWeight: 'normal' }}>
                {o.error_description.map((error) => {
                  return <li key={uuidv4()}>{this.convertToString(error)}</li>;
                })}
              </ol>
            </span>
          );
          this.setState({
            isModalOpen: false,
            modalIsOpen: true,
          });
        } else {
          this.setErrorMsg('license', o.error_description);
        }
      } else {
        this.setErrorMsg('license', t('modal.error.invalid_license'));
      }

      //this.isLoading = false;
      return err;
    }
  }

  async updateCompanySettings(data) {
    const { state, t } = this.props;
    let v;
    try {
      v = await api.updateCompanySettings(data);
      this.props.state.company.saveCompanyData(v.response);
      this.setState({
        licenseList: [],
        isModalOpen: false,
        //selectedRow: 0,
        quota: '',
        storage: '',
        errors: {
          license: '',
          name: '',
        },
      }, () => {
        if (state.user.isSuperAdmin) {
          this.getCompanyList(this.state.currentPage);
        }
        this.getQuotaData();
      });
      //this.isLoading = false;
      return v;
    } catch (err) {
      const o = err.data.response;

      if (o.error_description) {
        if (Array.isArray(o.error_description)) {
          this.modalBody = (
            <span>
              <div>Update failed: </div>
              <ol style={{ listStyle: 'decimal inside', fontWeight: 'normal' }}>
                {o.error_description.map((error) => {
                  return <li key={uuidv4()}>{this.convertToString(error)}</li>;
                })}
              </ol>
            </span>
          );
          this.setState({
            modalIsOpen: true,
          }, () => {
            v = null;
          });
        } else if (typeof o.error_description === 'string' && !Array.isArray(o.error_description)) {
          this.modalBody = (
            <span>
              <div>Update failed: </div>
              <ol style={{ listStyle: 'decimal inside', fontWeight: 'normal' }}>
                {this.convertToString(o.error_description)}
              </ol>
            </span>
          );
          this.setState({
            modalIsOpen: true,
          }, () => {
            v = null;
          });
        } else {
          this.setErrorMsg('license', err.data.error_description);
        }
      } else {
        this.setErrorMsg('license', t('modal.error.invalid_license'));
      }

      this.setState({
        isModalOpen: false,
      });
      //this.isLoading = false;
      return err;
    }
  }

  closeModal() {
    this.setState({
      isModalOpen: false,
      isRemoveModalOpen: false,
      modalIsOpen: false,
    });
  }

  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return (
      `${parseFloat((bytes / (k ** i)).toFixed(dm))} ${sizes[i]}`
    );
  }

  checkEmailValidate(value) {
    const { t } = this.props;
    const { emailList } = this.state;
    const isValidEmailAddressRegx = String(value).match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    if (!isValidEmailAddressRegx) {
      this.setErrorMsg('email', t('modal.error.invalid_email_address'));
      return false;
    }

    const checkDuplicate = emailList.filter((item) => {
      return item.name === value;
    });

    if (checkDuplicate.length !== 0) {
      this.setErrorMsg('email', t('modal.error.already_exist_email'));
      return false;
    }
    return true;
  }

  validateFields() {
    const { t } = this.props;
    const {
      licenseKey,
      name,
    } = this.props.state.company;

    const validation = {
      license: true,
    };

    if (licenseKey.length !== 20) {
      this.setErrorMsg('license', 'Invalid License');
      validation.license = false;
    } else {
      validation.license = true;
    }

    if (trim(name).length === 0) {
      this.setErrorMsg('name', t('modal.error.company_required'));
      validation.name = false;
    } else if (this.getByteLength(name) > 30) {
      this.setErrorMsg('name', t('modal.error.company_limit'));
      validation.name = false;
    } else {
      validation.name = true;
    }

    return (
      validation.license
      && validation.name
    );
  }

  clearSearch() {
    const { state } = this.props;
    this.search.value = '';
    this.setState({
      licenseList: [],
      searchKeyword: '',
    }, () => {
      if (state.user.isSuperAdmin) {
        this.getCompanyList(1);
      }
    });
  }

  convertToString(value) {
    const { t } = this.props;
    let text;
    switch (true) {
    case value === 'Already used key by different company. Press Create Company again':
      text = t('system.message.already_used_key_text');
      break;
    case value === 'Start date is bigger than expiration date':
      text = t('system.message.start_date_text');
      break;
    case value === 'Not supported license version. Please contact Insignary':
      text = t('system.message.not_support_license_version_text');
      break;
    case value === 'Can not find license key!':
      text = t('system.message.not_find_license_key_text');
      break;
    case value === 'Aleady registered license key!':
      text = t('system.message.already_registered_license_key_text');
      break;
    case value === 'Please use online key. This key is download file key':
      text = t('system.message.invalid_license_key_text');
      break;
    case value === 'License register error! Please contact Insignary':
      text = t('system.message.error_license_key');
      break;
    case value === 'Not registered license key!':
      text = t('system.message.not_registered_license_key');
      break;
    default:
      text = value;
      break;
    }
    return text;
  }

  render() {
    const {
      licenseList,
      hasMore,
      error,
      quota,
      storage,
      selectedRow,
      errSearch,
      isFocus,
      isCompanyLoading,
      isScrollLoading,
      isQuotaLoading,
      newEmailName,
      emailList,
    } = this.state;

    const { state, t } = this.props;

    const renderIfReady = (element) => {
      return (
        isQuotaLoading
          ? (
            <div style={{ height: '170px', paddingTop: '9%' }}>
              <Loader size="medium" active={isQuotaLoading} inline="centered" />
            </div>
          )
          : element
      );
    };
    //const mode = this.state.mode === 'edit' ? 'Edit' : 'Create';
    const modeMsg = this.state.mode === 'edit'
      ? (
        <div>
          <div className="text">{t('system.message.change_company')}</div>
          <div className="small_text">{t('system.message.change_company_confirm')}</div>
        </div>
      )
      : (
        <div>
          <div className="text">{t('system.message.create_new_company')}</div>
          <div className="small_text">{t('system.message.create_new_company_confirm')}</div>
        </div>
      );
    const btnDelete = this.state.mode === 'edit' && state.user.isSuperAdmin
      ? <a className="delete" onClick={this.handleDelete} style={{ cursor: 'pointer', backgroundColor: '#FFFFFF' }}>Delete</a>
      : null;

    return (
      <div>
        {
          <div className="content">
            <div className="setting_small_box">
              <h2 className="page_title">{t('system.title.storage')}</h2>
              {
                renderIfReady(
                  <div className="setting_contnets">
                    {
                      storage.allow_show_storage_info ? (
                        <div className="setting_contnet_wrap">
                          <h3 className="setting_content_title">
                            {t('system.title.storage')}
                            <em>
                              {this.formatBytes(storage.total_storage_space - storage.available_storage_space)}
                              /
                              {this.formatBytes(storage.total_storage_space)}
                            </em>
                          </h3>
                          <div className="setting_content">
                            <div className="progress purple">
                              <div className="bar bar_2" style={{ width: `${100 - Math.round((storage.available_storage_space / storage.total_storage_space) * 100)}%` }} />
                              {/*<div className="bar" style={{ width: '30%' }} />*/}
                              <div className="val">
                                {`${100 - Math.round((storage.available_storage_space / storage.total_storage_space) * 100)}%`}
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : null
                    }
                    {
                      quota.allow_show_quota && quota.quota_result.map((result) => {
                        return (
                          <div key={uuidv4()} className="setting_contnet_wrap">
                            <h3 className="setting_content_title">
                              { result.type === 'daily' && t('modal.new_scan.title.today_used')}
                              { result.type === 'total' && t('modal.new_scan.title.total_used')}
                              <em>
                                {' '}
                                {this.formatBytes(result.spent)}
                                {' '}
                                /
                                {' '}
                                { result.capacity === -1 ? t('modal.new_scan.title.unlimited') : (this.formatBytes(result.capacity))}
                              </em>
                            </h3>
                            <div className="setting_content">
                              <div className="progress">
                                {
                                  result.capacity === -1 ? (
                                    <div className="bar" style={{ width: '0%' }} />
                                  ) : (
                                    <div className="bar" style={{ width: `${Math.round((result.spent / result.capacity) * 100)}%` }} />
                                  )
                                }
                                <div className="val">
                                  {result.capacity === -1 ? t('modal.new_scan.title.unlimited') : (`${Math.round((result.spent / result.capacity) * 100)}%`)}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    }
                  </div>
                )
              }
              {
                state.user.isAdmin ? (
                  <div>
                    <div className="line" />

                    <h2 className="page_title">
                      {t('system.menu.license_sttings')}
                    </h2>
                    {
                      this.props.state.company.isLoading ? (
                        <div style={{ height: '180px', paddingTop: '9%' }}>
                          <Loader size="medium" active={this.props.state.company.isLoading} inline="centered" />
                        </div>
                      ) : (
                        <div className="setting_contnets">
                          <div className="setting_contnet_wrap">
                            <div className="left_content">
                              <h3 className="setting_content_title">{t('system.title.new_license_key')}</h3>
                              <div className="setting_content">
                                <table className="table">
                                  <colgroup>
                                    <col style={{ width: '50%' }} />
                                    <col style={{ width: '50%' }} />
                                  </colgroup>
                                  <tbody>
                                    <tr>
                                      <td>
                                        <InputElement
                                          onChange={this.handleChange}
                                          maskChar={null}
                                          placeholder="XXXXX-XXXXX-XXXXX-XXXXX"
                                          mask="*****-*****-*****-*****"
                                          value={this.props.state.company.licenseKey}
                                          alwaysShowMask
                                        />
                                      </td>
                                      <td>
                                        <Dropzone
                                          onDrop={this.handleDrop}
                                        >
                                          {({ getRootProps, getInputProps }) => {
                                            return (
                                              <div {...getRootProps({ className: 'green_button' })}>
                                                <input {...getInputProps()} />
                                                <p className="green_button">{t('modal.message.upload_license_file')}</p>
                                              </div>
                                            );
                                          }}
                                        </Dropzone>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colSpan="2">
                                        <div
                                          className={cx(
                                            'error',
                                            {
                                              show: this.state.errors.license,
                                            },
                                          )}
                                        >
                                          {this.state.errors.license}
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                            <div className="right_content">
                              <h3 className="setting_content_title">{t('system.title.validation_date')}</h3>
                              <div className="setting_content">
                                <table className="table">
                                  <colgroup>
                                    <col style={{ width: '15%' }} />
                                    <col style={{ width: '35%' }} />
                                    <col style={{ width: '15%' }} />
                                    <col style={{ width: '35%' }} />
                                  </colgroup>
                                  <tbody>
                                    <tr>
                                      <th>{t('system.title.start_date')}</th>
                                      <td>{this.props.state.company.licenseStartDate}</td>
                                      <th>{t('system.title.end_date')}</th>
                                      <td>{this.props.state.company.licenseExpirationDate}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                          <div className="setting_contnet_wrap">
                            <div className="left_content">
                              <h3 className="setting_content_title">{t('modal.title.company_name')}</h3>
                              <div className="setting_content">
                                <input
                                  type="text"
                                  value={this.props.state.company.name}
                                  onChange={this.handleNameChange}
                                />
                                <div
                                  className={cx(
                                    'error',
                                    {
                                      show: this.state.errors.name,
                                    },
                                  )}
                                >
                                  {this.state.errors.name}
                                </div>
                              </div>
                            </div>
                            <div className="right_content">
                              <div className="split_container">
                                <div className="split_item">
                                  <h3 className="setting_content_title">
                                    {t('system.list.license_key')}
                                  </h3>
                                  <div className="setting_content">
                                    <div className="readonly_text">
                                      {this.props.state.company.savedLicenseKey ? this.props.state.company.savedLicenseKey.match(LICENSE_REGEX).join('-') : ''}
                                    </div>
                                  </div>
                                </div>
                                <div className="split_item">
                                  <h3 className="setting_content_title">
                                    {t('system.list.license_type')}
                                  </h3>
                                  <div className="setting_content">
                                    <div className="readonly_text">
                                      {this.props.state.company.licenseType}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {
                            state.user.isSuperAdmin
                            && (
                              <div className="setting_contnet_wrap">
                                <div className="left_content">
                                  <h3 className="setting_content_title">{t('system.list.scan_notification')}</h3>
                                  <div className="setting_content">
                                    <table className="table">
                                      <colgroup>
                                        <col style={{ width: '70%' }} />
                                        <col style={{ width: '30%' }} />
                                      </colgroup>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <input
                                              type="text"
                                              value={newEmailName}
                                              onChange={this.handleEmailChange}
                                              onKeyPress={this.addNewEmailKeyPress}
                                              placeholder={`${t('system.list.example')} no-reply@insignary.com`}
                                            />
                                            <div
                                              className={cx(
                                                'error',
                                                {
                                                  show: this.state.errors.email,
                                                },
                                              )}
                                            >
                                              {this.state.errors.email}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="button_wrapper">
                                              <a
                                                className="add_button"
                                                style={{ cursor: 'pointer' }}
                                                onClick={this.addNewEmail}
                                                onKeyUp={this.addNewEmail}
                                              >
                                                +
                                                {' '}
                                                {t('system.title.add_new_email')}
                                              </a>
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                  <div className="setting_content" style={{ marginTop: '31px' }}>
                                    <Scrollbars
                                      renderTrackHorizontal={() => {
                                        return <div />;
                                      }}
                                      renderThumbHorizontal={() => {
                                        return <div />;
                                      }}
                                      autoHeight
                                      autoHeightMin={0}
                                      autoHeightMax={230}
                                    >
                                      {
                                        emailList.length === 0 ? (
                                          <Message className="empty">
                                            <Message.Header>{t('system.title.no_email_list')}</Message.Header>
                                          </Message>
                                        ) : (
                                          <div>
                                            {emailList.map((item) => {
                                              if (item.id !== 'new') {
                                                return (
                                                  <ul key={item.name.toString()}>
                                                    <Message className="content">
                                                      <Icon name="mail" />
                                                      {item.name}
                                                      <Icon
                                                        name="close"
                                                        onClick={() => {
                                                          return this.removeEmail(item.name);
                                                        }}
                                                      />
                                                    </Message>
                                                  </ul>
                                                );
                                              }
                                              return (
                                                <ul key={item.name.toString()}>
                                                  <Message className="content">
                                                    <Icon name="mail" />
                                                    {item.name}
                                                   &nbsp;(NEW)
                                                    <Icon
                                                      name="close"
                                                      onClick={() => {
                                                        return this.removeEmail(item.name);
                                                      }}
                                                    />
                                                  </Message>
                                                </ul>
                                              );
                                            })}
                                          </div>
                                        )
                                      }
                                    </Scrollbars>
                                  </div>
                                </div>
                                <div className="right_content">&nbsp;</div>
                              </div>
                            )
                          }
                        </div>
                      )
                    }
                    {
                      state.user.isSuperAdmin ? (
                        <div className="setting_project_content" style={{ margin: '30px 0 30px 0' }}>
                          <div className="line" />
                          <div className="button_wrapper">
                            { this.state.mode === 'edit'
                              ? (
                                <a className="add_button" onClick={this.handleAdd}>
                                  +
                                  {' '}
                                  {t('system.button.add_new_company')}
                                </a>
                              ) : null}
                          </div>
                          <div className="search_files_wrap">
                            <img src={searchIcon} alt="" className="icon" />
                            <input
                              ref={(ref) => { this.search = ref; }}
                              placeholder="Serial, Company, Managed Name"
                              type="search_files"
                              onKeyPress={this.handleSearch}
                              onFocus={this.handleFocus}
                              onBlur={this.handleBlur}
                            />
                            <a className="reset_icon" onClick={this.clearSearch}>x</a>
                            {errSearch && (
                              <Label basic color="red" pointing>
                                {t('contents_header.message.least_two_required_to_search')}
                              </Label>
                            )}
                            {isFocus && (
                              <Label pointing>{t('system.list.label_company')}</Label>
                            )}
                          </div>
                          <table className="setting_project_table table_header">
                            <colgroup>
                              <col style={{ width: '7.9%', maxWidth: '70px' }} />
                              <col style={{ width: '13.6%', maxWidth: '120px' }} />
                              <col style={{ width: '13.6%', maxWidth: '120px' }} />
                              <col style={{ width: '11.2%', maxWidth: '97.5px' }} />
                              <col style={{ width: '11.2%', maxWidth: '97.5px' }} />
                              <col style={{ width: '11.2%', maxWidth: '97.5px' }} />
                              <col style={{ width: '11.2%', maxWidth: '97.5px' }} />
                              <col style={{ width: '20%', maxWidth: '180px' }} />
                            </colgroup>
                            <thead>
                              <tr>
                                <th>{t('system.list.serial')}</th>
                                <th>{t('system.list.company_name')}</th>
                                <th>{t('system.list.managed_name')}</th>
                                <th>{t('system.list.preiod_usage')}</th>
                                <th>{t('system.list.today_usage')}</th>
                                <th>
                                  {t('system.list.all_usage')}
                                  e
                                </th>
                                <th>{t('system.list.scan_notification')}</th>
                                <th>{t('system.list.license_key')}</th>
                              </tr>
                            </thead>
                          </table>
                          {
                            isCompanyLoading ? (
                              <div style={{ paddingTop: '16%', height: '300px', postion: 'relative' }}>
                                <Loader active={isCompanyLoading} inline="centered" />
                              </div>
                            ) : (
                              <div style={{ height: '300px', position: 'relative', overflow: 'hidden' }}>
                                <Scrollbars
                                  renderTrackHorizontal={() => {
                                    return <div />;
                                  }}
                                  renderThumbHorizontal={() => {
                                    return <div />;
                                  }}
                                  onScroll={this.handleOnScroll}
                                >
                                  {
                                    licenseList.length !== 0 ? (
                                      licenseList.map((list, index) => {
                                        return (
                                          <div key={uuidv4()} className="setting_project_table_wrap">
                                            <table className="setting_project_table">
                                              <colgroup>
                                                <col style={{ width: '7.9%', maxWidth: '70px' }} />
                                                <col style={{ width: '13.6%', maxWidth: '120px' }} />
                                                <col style={{ width: '13.6%', maxWidth: '120px' }} />
                                                <col style={{ width: '11.2%', maxWidth: '97.5px' }} />
                                                <col style={{ width: '11.2%', maxWidth: '97.5px' }} />
                                                <col style={{ width: '11.2%', maxWidth: '97.5px' }} />
                                                <col style={{ width: '11.2%', maxWidth: '97.5px' }} />
                                                <col style={{ width: '20%', maxWidth: '180px' }} />
                                              </colgroup>
                                              <tbody>
                                                <tr
                                                  className={cx('hover_area', {
                                                    selected: selectedRow === index,
                                                  })}
                                                  onClick={() => { return (this.handleClick(index)); }}
                                                >
                                                  <td><div className="content_wrapper" style={{ lineHeight: '40px' }}>{list.companyId}</div></td>
                                                  <td><div className="content_wrapper" style={{ lineHeight: '40px' }}>{list.companyName}</div></td>
                                                  <td><div className="content_wrapper" style={{ lineHeight: '40px' }}>{list.managedName}</div></td>
                                                  <td><div className="content_wrapper" style={{ lineHeight: '40px' }}>{list.periodUsage}</div></td>
                                                  <td><div className="content_wrapper" style={{ lineHeight: '40px' }}>{list.todayUsage}</div></td>
                                                  <td><div className="content_wrapper" style={{ lineHeight: '40px' }}>{list.allUsage}</div></td>
                                                  <td><div className="content_wrapper" style={{ lineHeight: '40px' }}>{list.emailCount}</div></td>
                                                  <td>
                                                    <div className="content_wrapper" style={{ lineHeight: '40px' }}>
                                                      {list.licenseKey === '' ? (
                                                        list.licenseKey
                                                      ) : (
                                                        list.licenseKey.match(/.{1,5}/g).join('-')
                                                      )}
                                                    </div>

                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        );
                                      })
                                    ) : null
                                  }
                                  {error
                                    && (
                                      <div style={{ color: '#900' }}>
                                        {error}
                                      </div>
                                    )}
                                  {isScrollLoading && <Loader active={isScrollLoading} size="small" inline="centered" />}
                                  {!hasMore && null}
                                </Scrollbars>
                              </div>
                            )
                          }
                        </div>
                      ) : null
                    }
                    <div className="setting_bottom">
                      { btnDelete }
                      {/*<a className="revert">Revert</a>*/}
                      <a className="save" onClick={this.handleSave} style={{ cursor: 'pointer' }}>{t('modal.button.save')}</a>
                    </div>
                  </div>
                ) : null
              }
            </div>
          </div>
        }
        <Modal
          open={this.state.isModalOpen}
          onClose={this.closeModal}
        >
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">
                  {t('modal.title.attention')}
                </h2>
                <div className="text">
                  { modeMsg }
                </div>
                <div className="button_wrap">
                  <a onClick={this.closeModal} className="left_button">{t('modal.button.no')}</a>
                  <a onClick={this.handleModal} className="right_button">{t('modal.button.yes')}</a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          open={this.state.isRemoveModalOpen}
          onClose={this.closeModal}
        >
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">
                  {t('modal.title.attention')}
                </h2>
                <div className="text">
                  {t('system.message.remove_company')}
                </div>
                <div className="small_text">
                  {t('system.message.remove_company_confirm')}
                </div>
                <div className="button_wrap">
                  <a onClick={this.closeModal} className="left_button">{t('modal.button.no')}</a>
                  <a onClick={this.handleRemoveModal} className="right_button">{t('modal.button.yes')}</a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          open={this.state.modalAlert}
          onClose={this.handleCloseAlert}
        >
          <div className="modal_popup_wrap error_wrap">
            <div className="modal_popup_box error_box">
              <div className="modal_popup error">
                <h2 className="title">
                  {this.state.modalAlertTitle}
                </h2>
                <div className="text">
                  {this.state.modalAlertMsg}
                </div>
                <div className="button_wrap">
                  <a onClick={this.handleCloseAlert} className="center_button">{t('modal.button.ok')}</a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          open={this.state.modalIsOpen}
          onClose={this.closeModal}
        >
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">
                  {t('modal.title.attention')}
                </h2>
                <div className="text">
                  {this.modalBody}
                </div>
                <div className="button_wrap">
                  <a onClick={this.closeModal} className="center_button">{t('modal.button.close')}</a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default withTranslation()(inject('state')(observer(LicenseSystem)));
